var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "open-document-wrapper v-full" }, [
    _c(
      "div",
      { staticClass: "upload-container" },
      [
        _c(
          "file-dropzone",
          {
            staticClass: "file-dropzone-area",
            attrs: { multiple: "" },
            model: {
              value: _vm.resultDropFiles,
              callback: function ($$v) {
                _vm.resultDropFiles = $$v
              },
              expression: "resultDropFiles",
            },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "flex-grow flex flex-col pb-4 text-center text-lg text-blue-800 h-24 border-solid border border-gray-500",
              },
              [
                _c("file-field", {
                  staticClass: "h-24",
                  attrs: {
                    accept: ".txt,.csv,.xls,.xlsx,.doc,.docx,.pdf,.jpg,.png",
                    multiple: "",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.onFilesChange($event)
                    },
                  },
                  model: {
                    value: _vm.updateFiles,
                    callback: function ($$v) {
                      _vm.updateFiles = $$v
                    },
                    expression: "updateFiles",
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "h-20 border-solid border border-gray-500 mt-2 mb-2" },
          [
            _c(
              "div",
              { staticClass: "text-left text-md text-blue-800 px-2 h-8" },
              [_vm._v(_vm._s(_vm.uploadStatus))]
            ),
            _vm._v(" "),
            _c("progress-bar", {
              staticClass: "mt-2 mb-2 h-8",
              attrs: { "progress-value": _vm.progressValue },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex-grow flex flex-col h-108" },
      [
        _c(
          "grid",
          {
            key: _vm.gridKey,
            ref: "documentRequestsGrid",
            staticClass: "h-full flex flex-grow h-full h-108",
            attrs: {
              "row-data": _vm.successfulUploads,
              "floating-filter": false,
              "data-selector": "preview-grid",
              "get-row-id": _vm.getRowId,
            },
          },
          [
            _c("grid-column", {
              attrs: {
                "header-name": "id",
                field: "id",
                weight: "0",
                hide: "true",
              },
            }),
            _vm._v(" "),
            _c("grid-column", {
              attrs: {
                "header-name": "Document Name",
                weight: "2",
                width: "200",
                field: "documentName",
              },
            }),
            _vm._v(" "),
            _c("grid-column", {
              attrs: {
                "header-name": "Document Type",
                weight: "1",
                width: "200",
                editable: true,
                "cell-editor-popup": true,
                "cell-class": () => ["editable-cell", "leftAlign"],
                "value-getter": _vm.getDocumentTypeNameColumnValue,
                "cell-renderer": "cellDropTargetRenderer",
                "cell-renderer-params": { onDrop: _vm.onDropDocumentType },
                "cell-editor": "dropdownInputCellEditor",
                "cell-editor-params": {
                  textField: "name",
                  enableClear: true,
                  enableSearch: true,
                  valueField: "id",
                  source: _vm.documentTypes,
                },
                field: "packageDocumentTypeId",
              },
            }),
            _vm._v(" "),
            _c("grid-column", {
              attrs: {
                "header-name": "Document Tag",
                weight: "1",
                width: "200",
                editable: true,
                "cell-editor-popup": true,
                field: "documentTag",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }